import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { debounce } from "../../../utils/debounce";

export const useDynamicHeight = (passHeight = 700) => {
  const [height, setHeight] = useState<number | undefined>(undefined);
  const location = useLocation();

  const calculateHeight = useCallback(() => {
    if (passHeight) {
      const screenHeight = window.innerHeight;
      setHeight(screenHeight - passHeight);
    }
  }, [passHeight, location.pathname]);

  useEffect(() => {
    calculateHeight();

    const debouncedResize = debounce(calculateHeight, 171);

    window.addEventListener("resize", debouncedResize);
    return () => window.removeEventListener("resize", debouncedResize);
  }, [calculateHeight]);

  return { height };
};
